import { Box } from "@chakra-ui/layout";
import { forwardRef } from "react";
import { SPACING } from "../constants/Constants";
import { Button as NativeButton, ButtonProps as NativeButtonProps } from "@chakra-ui/button";

interface ButtonProps extends NativeButtonProps {
}

const Button = forwardRef<HTMLInputElement, ButtonProps>(({ ...props }, ref) => {
    return (
        <Box m={SPACING / 1.5}>
            <NativeButton ref={ref} {...props} />
        </Box>
    );
});

export default Button;
